import { combineReducers } from 'redux';
import { isLoadingReducer } from 'store/reducerUtils';
import { associateDealTypePayCodeArBucket } from './actions';

const isAssociationInProgress = isLoadingReducer(associateDealTypePayCodeArBucket);

export const payCodeArBucket = combineReducers({
    isAssociationInProgress,
});
